"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFacilitiesModal = UserFacilitiesModal;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var user_1 = require("../../features/apis/user");
var api_error_message_1 = require("../../utils/api-error-message");
var button_component_1 = require("../ui/button-component");
var facility_picker_list_1 = require("../ui/facility-picker-list");
var text_component_1 = require("../ui/text-component");
function UserFacilitiesModal(props) {
    var _this = this;
    var user = props.user, clientId = props.clientId, userId = props.userId, onClose = props.onClose;
    var _a = (0, react_2.useState)(function () { var _a; return new Set(((_a = user.facilities) !== null && _a !== void 0 ? _a : []).map(function (facility) { return facility.id; })); }), facilityIds = _a[0], setFacilityIds = _a[1];
    var _b = (0, react_2.useState)(""), error = _b[0], setError = _b[1];
    var _c = (0, user_1.useUpdateUserFacilitiesMutation)(), updateUserFacilities = _c[0], isSaving = _c[1].isLoading;
    var requestTokenRef = (0, react_2.useRef)(0);
    var requestInFlightRef = (0, react_2.useRef)(false);
    (0, react_2.useEffect)(function () { return function () {
        requestTokenRef.current += 1;
    }; }, []);
    var fullName = [user.name, user.surname].filter(Boolean).join(" ") || user.email;
    var handleClose = function () {
        if (requestInFlightRef.current || isSaving)
            return;
        requestTokenRef.current += 1;
        onClose();
    };
    var toggleFacility = function (facilityId) {
        setError("");
        setFacilityIds(function (previousFacilityIds) {
            var nextFacilityIds = new Set(previousFacilityIds);
            if (nextFacilityIds.has(facilityId)) {
                nextFacilityIds.delete(facilityId);
            }
            else {
                nextFacilityIds.add(facilityId);
            }
            return nextFacilityIds;
        });
    };
    var handleSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var requestToken, response, requestError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (requestInFlightRef.current)
                        return [2 /*return*/];
                    if (facilityIds.size === 0) {
                        setError("Please select at least one facility.");
                        return [2 /*return*/];
                    }
                    setError("");
                    requestToken = requestTokenRef.current;
                    requestInFlightRef.current = true;
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, updateUserFacilities({ id: user.uid || user.id, facilities: Array.from(facilityIds) }).unwrap()];
                case 2:
                    response = _a.sent();
                    if (requestToken !== requestTokenRef.current)
                        return [2 /*return*/];
                    if (!response.success) {
                        setError(response.message || "Unable to update facilities. Please try again.");
                        return [2 /*return*/];
                    }
                    requestInFlightRef.current = false;
                    handleClose();
                    return [3 /*break*/, 5];
                case 3:
                    requestError_1 = _a.sent();
                    if (requestToken !== requestTokenRef.current)
                        return [2 /*return*/];
                    setError((0, api_error_message_1.getApiErrorMessage)(requestError_1, "Unable to update facilities. Please try again."));
                    return [3 /*break*/, 5];
                case 4:
                    requestInFlightRef.current = false;
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(react_1.Modal, { isOpen: true, onOpenChange: function (open) {
            if (!open)
                handleClose();
        }, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Backdrop, { isDismissable: !isSaving, isKeyboardDismissDisabled: isSaving, children: (0, jsx_runtime_1.jsx)(react_1.Modal.Container, { children: (0, jsx_runtime_1.jsxs)(react_1.Modal.Dialog, { className: "sm:max-w-[520px]", children: [(0, jsx_runtime_1.jsx)(react_1.Modal.CloseTrigger, { isDisabled: isSaving }), (0, jsx_runtime_1.jsx)(react_1.Modal.Header, { children: (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "large", weight: "bold", color: "dark-gray-1", label: "Facilities" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", label: "Choose which facilities ".concat(fullName, " works in.") })] }) }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Body, { children: [(0, jsx_runtime_1.jsx)(facility_picker_list_1.FacilityPickerList, { isActive: true, clientId: clientId, userId: userId, selectedIds: facilityIds, onToggle: toggleFacility, isDisabled: isSaving }), error && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: error }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.Modal.Footer, { children: [(0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Cancel", onPress: handleClose, isDisabled: isSaving, variant: "secondary" }), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Save Facilities", onPress: handleSave, isPending: isSaving, isDisabled: isSaving || facilityIds.size === 0 })] })] }) }) }) }));
}
